module.exports = __webpack_public_path__ + "img/bb@2x.899d0cc8.png";